/* SBM fichas de producto — propuesta 2026-10-06
   1) "Agregar" de Completa tu equipo por AJAX sin salir de la página.
   2) Barra fija de compra en celular que usa el formulario principal del producto. */
(function () {
  if (window.__sbmPdp) return;
  window.__sbmPdp = true;

  function refreshCartBubble() {
    return fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        var el = document.getElementById('cart-icon-bubble');
        if (!html || !el) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        el.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sbm-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-sbm-add')), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.textContent = 'Agregado ✓';
        btn.classList.add('is-added');
        return refreshCartBubble();
      })
      .catch(function () {
        btn.textContent = 'Intenta de nuevo';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = label; }, 2500);
      });
  });

  function initSticky() {
    var bar = document.querySelector('[data-sbm-sticky]');
    var mainBtn = document.querySelector('product-info .product-form__submit, .product__info-container .product-form__submit');
    if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var below = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', below);
      document.body.classList.toggle('sbm-sticky-on', below);
    });
    io.observe(mainBtn);
    bar.querySelector('[data-sbm-sticky-btn]').addEventListener('click', function () {
      if (mainBtn.disabled) {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainBtn.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
